import { useNavigate } from 'react-router-dom';
import {
  WList,
  WListItem,
  WListItemAvatar,
  WListItemText,
  WStack,
  WTypography,
} from '../../wrappers/wrapper';
import styles from './channel-card.module.scss';
import { FC, Fragment, useState } from 'react';
import ProfilePhoto from '../../molecules/profile-photo/profile-photo';
import ViewProfile from '../view-profile-popover/view-profile-popover';
import { TArticle, TChannelCard, TUser } from '../../../models/common';

interface ChannelCardProps {
  className?: string;
  data: TChannelCard;
}

const ChannelCard: FC<ChannelCardProps> = ({ className, data }) => {
  const navigate = useNavigate();
  const articles = (data?.articles?.slice(0, 5) || []) as TArticle[];

  const [userId, setUserId] = useState<string>();

  const navigateToArticle = (article_id: string) => {
    navigate(article_id);
  };

  const classes = `${styles.channelCard} ${className || ''}`.trim();
  return (
    <WStack className={classes}>
      <WTypography className={styles['title']}>{data.title}</WTypography>
      <WList>
        {articles.map((article) => (
          <WListItem alignItems="flex-start" className={styles['list-item']} key={article._id}>
            <WListItemAvatar
              onClick={() => setUserId((article.publisher as TUser)._id)}
              className={styles['avatar']}
            >
              <ProfilePhoto width="40px" height="40px" user={article.publisher} />
            </WListItemAvatar>
            <WListItemText
              className={styles['text']}
              onClick={() => navigateToArticle(article._id!)}
              primary={article.title}
              secondary={
                <Fragment>
                  <WTypography
                    className={styles['secondary-text']}
                    onClick={(e) => {
                      e.stopPropagation();
                      setUserId((article.publisher as TUser)._id);
                    }}
                    variant="body2"
                  >
                    {(article.publisher as TUser).username}
                  </WTypography>
                </Fragment>
              }
            />
          </WListItem>
        ))}
      </WList>
      {userId && (
        <ViewProfile
          user_id={userId}
          onClose={() => setUserId('')}
          showEditButton={false}
        ></ViewProfile>
      )}
    </WStack>
  );
};

export default ChannelCard;
